export const FETCH_ALL_MESSAGES = "FETCH_ALL_MESSAGES";
export const ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
export const GET_USERS = 'GET_USERS';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const GET_GROUP_MEMBERS = 'GET_GROUP_MEMBERS'
export const GET_GROUP_ADMIN = 'GET_GROUP_ADMIN'
export const GET_GROUP_NAME = 'GET_GROUP_NAME'
export const GET_GROUP_PIC = 'GET_GROUP_PIC'
export const GET_ALL_GROUPS = 'GET_ALL_GROUPS'
export const UPDATE_A_GROUP = 'UPDATE_A_GROUP'
export const GET_ALL_GROUP_MESSAGES = 'GET_ALL_GROUP_MESSAGES'
export const GET_SEARCHED_MEMBERS = 'GET_SEARCHED_MEMBERS'
export const ADD_GROUP_MEMBER = 'ADD_GROUP_MEMBER'
export const REMOVE_GROUP_MEMBER = 'REMOVE_GROUP_MEMBER'